import { Select, createListCollection } from '@chakra-ui/react';
import type { SelectRootProps } from '@chakra-ui/react';
import type { Placement } from '@floating-ui/dom';
import type { ReactNode } from 'react';

export default function SelectComp<T>(
  props: Omit<SelectRootProps, 'collection'> & {
    items: {
      label: string;
      value: T;
    } & Record<string, any>[];
    showClear?: boolean;
    placeholder?: string;
    onClear?: () => void;
    showSearch?: boolean;
    onSearch?: (val?: string) => void;
    cssBody?: any;
    itemRender?: (val: Record<string, any>) => ReactNode;
    contentWidth?: number;
    placement?: Placement;
  }
) {
  const collection = useMemo(
    () => createListCollection({ items: props.items ?? [] }),
    [props.items]
  );
  const { showClear, showSearch, onClear, onSearch, cssBody, placeholder, itemRender, ...rest } =
    props;

  return (
    <Select.Root
      cursor="pointer"
      bg="white"
      borderRadius={'6px'}
      css={{
        '--radii-l2': '6px',
      }}
      {...rest}
      collection={collection}
    >
      <Select.HiddenSelect />
      <Select.Control
        css={{
          '--radii-l2': '6px',
        }}
      >
        <Select.Trigger>
          <Select.ValueText placeholder={placeholder ?? ''} />
        </Select.Trigger>
        <Select.IndicatorGroup>
          <Select.Indicator />
        </Select.IndicatorGroup>
      </Select.Control>
      <Select.Positioner>
        <Select.Content
          css={{
            '--radii-l2': '6px',
          }}
        >
          {collection.items?.map((item) => (
            <Select.Item
              fontSize={'13px'}
              item={item}
              key={`${item.value}`}
              h="40px"
              flex="none"
              fontWeight={600}
              borderRadius={'4px'}
              css={{ '--mix-background': 'rgba(0, 0, 0, 0.03)' }}
            >
              {props.itemRender ? props.itemRender(item) : item.label}
              <Select.ItemIndicator />
            </Select.Item>
          ))}
        </Select.Content>
      </Select.Positioner>
    </Select.Root>
  );
}
